import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"

import { StaticQuery, graphql } from "gatsby"

const StyledHeader = styled.header`
  background-color: #000;

  > div {
    position: relative;
    margin: 0 auto;
    padding: .5rem 1rem;
    display: flex;
    max-width: 1800px;

    @media( min-width: 1600px ) {
      &:after {
        position: absolute;
        content: 'Stumbling my way through the web';
        font-size: 64px;
        bottom: 0;
        right: 0;
        color: #202020;
      }
    }
  }

  img {
    margin: 0;
  }

  ul {
    display: flex;
    list-style: none;
    margin: 0;
  }

  li {
    padding: .5rem 1rem 0;
    text-transform: uppercase;
  }

  h1 a {
    color: #FFB414;
    line-height: 2.25rem;
  }

  a {
    color: #DABDAB;
    font-family: Viga;
    letter-spacing: 1;
    text-decoration: none;
    display: inherit;
  }
`;

const StylesHeaderContent = styled.div`
margin-left: 2rem;
ul {
  justify-content: center;
}
li {
  a {
    z-index: 1;
    position: relative;
    -webkit-text-stroke-width: .5px;
    -webkit-text-stroke-color: black;
    text-shadow:
      3px 3px 0 #000,
      -1px -1px 0 #000,
      1px -1px 0 #000,
      -1px 1px 0 #000,
      1px 1px 0 #000;
  }

  a::after {
    content: '';
    display: block;
    width: 0;
    height: 20px;
    background-color: #D81159;
    position: relative;
    bottom: 20px;
    z-index: -1;
    opacity: 1;
    transition: all .025s ease-in-out;
    left: -15%;
    transform: rotate(-12deg);
}
  a:hover {
    &::after {
      width: 130%;
    }
  }
}
`;

const StyledSocialLinks = styled.div`
margin-left: auto;
`;

const Header = () => (
  <StaticQuery
  query={query}
  render={(data) => {
    let {site, logo, wordpressWpApiMenusMenusItems} = data;
    console.log(data);
    return (
      <StyledHeader>
        <div>
        <Link to="/"><Img fixed={logo.childImageSharp.fixed} alt="Screaming Code Monkey Logo" /></Link>
        <StylesHeaderContent>
          <h1 style={{ margin: 0 }}>
            <Link to="/">{site.siteMetadata.title}</Link>
          </h1>
          <ul>
            {wordpressWpApiMenusMenusItems.items.map((item) => (
            <li key={item.url}>
              <Link to={item.url}>
                {item.title}
              </Link>
            </li>
            ))}
          </ul>
        </StylesHeaderContent>
        <StyledSocialLinks>
          <ul>
            <li>
              <a href="https://github.com/jghazally">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.15625 18.6094C8.15625 18.6094 8.10938 18.5625 8.0625 18.5156C8.01562 18.5156 7.96875 18.4688 7.875 18.4688C7.6875 18.4688 7.64062 18.5625 7.64062 18.6562C7.64062 18.7969 7.6875 18.8438 7.875 18.8438C8.0625 18.8438 8.15625 18.75 8.15625 18.6094ZM6.70312 18.4219C6.70312 18.3281 6.79688 18.2812 6.98438 18.3281C7.125 18.375 7.17188 18.4219 7.17188 18.5156C7.17188 18.6094 7.125 18.6562 7.07812 18.6562C6.98438 18.7031 6.9375 18.7031 6.89062 18.6562C6.79688 18.6562 6.75 18.6094 6.70312 18.5625C6.65625 18.5156 6.65625 18.4688 6.70312 18.4219ZM8.76562 18.3281C8.90625 18.3281 9 18.375 9 18.4688C9 18.5625 8.95312 18.6562 8.8125 18.7031C8.71875 18.7031 8.67188 18.7031 8.625 18.7031C8.57812 18.7031 8.53125 18.6094 8.53125 18.5156C8.53125 18.4219 8.57812 18.375 8.76562 18.3281ZM11.8594 0.375C13.9688 0.375 15.9375 0.890625 17.7656 1.875C19.5469 2.90625 21 4.26562 22.0312 5.95312C23.0625 7.73438 23.625 9.70312 23.625 11.8125C23.625 14.4375 22.875 16.7344 21.4219 18.7969C19.9688 20.8594 18.0938 22.2656 15.75 23.0156C15.4688 23.1094 15.2812 23.0625 15.1406 22.9219C15 22.8281 14.9531 22.6406 14.9531 22.4531V18.5156C14.9531 17.5312 14.6719 16.8281 14.1562 16.3594C15.2812 16.2656 16.1719 16.0781 16.7344 15.8906C17.5781 15.6094 18.2812 15.1406 18.75 14.4844C19.2656 13.6875 19.5469 12.5625 19.5469 11.1562C19.5469 10.5938 19.4062 10.0781 19.2188 9.60938C19.0312 9.32812 18.75 8.90625 18.3281 8.4375C18.4219 8.15625 18.5156 7.78125 18.5625 7.3125C18.5625 6.65625 18.4688 5.95312 18.2344 5.25C17.9062 5.15625 17.4844 5.25 16.9219 5.4375C16.5469 5.625 16.0781 5.8125 15.6094 6.09375L15 6.51562C14.0156 6.23438 13.0312 6.09375 12 6.09375C10.9688 6.09375 10.0312 6.23438 9.09375 6.51562L8.48438 6.09375C7.96875 5.8125 7.5 5.625 7.125 5.4375C6.5625 5.25 6.14062 5.15625 5.85938 5.25C5.57812 5.95312 5.4375 6.65625 5.53125 7.3125C5.53125 7.78125 5.57812 8.10938 5.71875 8.39062C5.34375 8.85938 5.0625 9.32812 4.875 9.70312C4.6875 10.0781 4.64062 10.5938 4.64062 11.1562C4.64062 12.5625 4.875 13.6875 5.39062 14.4375C5.8125 15.0938 6.46875 15.6094 7.35938 15.8906C7.92188 16.0781 8.76562 16.2656 9.89062 16.3594C9.46875 16.7344 9.23438 17.2969 9.14062 17.9531C8.57812 18.2344 8.0625 18.3281 7.59375 18.2344C6.75 18.1875 6.14062 17.7656 5.71875 16.9688C5.53125 16.6406 5.25 16.3594 4.96875 16.125C4.73438 16.0312 4.5 15.8906 4.26562 15.7969L3.9375 15.75C3.5625 15.75 3.375 15.8438 3.375 15.9375C3.375 16.0312 3.42188 16.1719 3.60938 16.2656L3.84375 16.4531C4.03125 16.5938 4.26562 16.7812 4.5 17.0625C4.6875 17.2969 4.82812 17.5312 4.96875 17.8125L5.15625 18.1875C5.29688 18.6562 5.57812 19.0312 6.04688 19.2656C6.42188 19.5 6.84375 19.6406 7.40625 19.6875C7.78125 19.7344 8.15625 19.7344 8.57812 19.6406L9.09375 19.5938L9.14062 22.4531C9.14062 22.6406 9.04688 22.8281 8.90625 22.9219C8.76562 23.0625 8.57812 23.1094 8.34375 23.0156C5.95312 22.2656 4.03125 20.8594 2.57812 18.7969C1.07812 16.7344 0.375 14.4375 0.375 11.8125C0.375 9.70312 0.84375 7.78125 1.875 6C2.85938 4.26562 4.21875 2.90625 6 1.875C7.73438 0.890625 9.70312 0.375 11.8594 0.375ZM4.92188 16.5469C4.96875 16.5 5.0625 16.5 5.15625 16.5938C5.25 16.6875 5.25 16.7812 5.20312 16.8281C5.10938 16.9219 5.0625 16.875 4.96875 16.7812C4.875 16.6875 4.82812 16.6406 4.92188 16.5469ZM4.40625 16.1719C4.45312 16.125 4.54688 16.125 4.64062 16.1719C4.73438 16.2188 4.73438 16.2656 4.73438 16.3594C4.6875 16.4531 4.59375 16.4531 4.5 16.3594C4.40625 16.3125 4.35938 16.2656 4.40625 16.1719ZM5.95312 17.8125C5.95312 17.8125 6 17.8125 6.09375 17.8125C6.14062 17.8125 6.1875 17.8594 6.23438 17.9062C6.28125 17.9531 6.32812 18 6.32812 18.0469C6.32812 18.1406 6.32812 18.1875 6.32812 18.1875C6.23438 18.2812 6.09375 18.2812 6 18.1406C5.90625 18.0938 5.90625 18.0469 5.90625 17.9531C5.90625 17.9062 5.90625 17.8594 5.95312 17.8125ZM5.39062 17.1562C5.4375 17.1562 5.48438 17.1562 5.53125 17.1562C5.57812 17.1562 5.625 17.2031 5.67188 17.25C5.76562 17.3906 5.76562 17.4844 5.67188 17.5312C5.625 17.5781 5.57812 17.5781 5.53125 17.5312C5.48438 17.5312 5.4375 17.4844 5.39062 17.4375C5.29688 17.2969 5.29688 17.2031 5.39062 17.1562Z" fill="#B2B2B2"/>
                </svg>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/jeffry-ghazally-563a3a13?originalSubdomain=nz">
                <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.6875 21.5V7.48438H0.328125V21.5H4.6875ZM2.53125 5.5625C3.1875 5.5625 3.79688 5.32812 4.3125 4.8125C4.78125 4.34375 5.0625 3.73438 5.0625 3.03125C5.0625 2.375 4.78125 1.76562 4.3125 1.25C3.79688 0.78125 3.1875 0.5 2.53125 0.5C1.82812 0.5 1.21875 0.78125 0.75 1.25C0.234375 1.76562 0 2.375 0 3.03125C0 3.73438 0.234375 4.34375 0.75 4.8125C1.21875 5.32812 1.82812 5.5625 2.53125 5.5625ZM21 21.5V13.8125C21 11.6562 20.6719 10.0625 20.0625 9.03125C19.2188 7.76562 17.8125 7.10938 15.7969 7.10938C14.7656 7.10938 13.9219 7.39062 13.1719 7.85938C12.4688 8.28125 11.9531 8.79688 11.6719 9.40625H11.625V7.48438H7.45312V21.5H11.7656V14.5625C11.7656 13.4844 11.9062 12.6406 12.2344 12.0781C12.6094 11.3281 13.3125 10.9531 14.3438 10.9531C15.3281 10.9531 15.9844 11.375 16.3594 12.2188C16.5469 12.7344 16.6406 13.5312 16.6406 14.6562V21.5H21Z" fill="#B2B2B2"/>
                </svg>
              </a>
            </li>
          </ul>
        </StyledSocialLinks>
        </div>
      </StyledHeader>
      )}
      }
    />
)

export const query = graphql`
  query HeaderQuery {
    site {
      siteMetadata {
        title
      }
    }
    logo: file(relativePath: { eq: "monkey.jpeg" }) {
      childImageSharp {
        fixed (
          width: 80
          quality: 100
        ){
          ...GatsbyImageSharpFixed
        }
      }
    }
    wordpressWpApiMenusMenusItems(slug: { eq: "primary"}){
      items {
        title
        url
      }
    }
  }
`

export default Header
